<template>
  <div class="flex" style="width: 100%">
    <a-slider
      class="flex-grow"
      :min="config.min || 0"
      :max="config.max || 100"
      :step="config.step || 1"
      v-model:value="field.value"
      @change="handleChange"
    />
    <a-input-number
      class="flex-shrink-0 ml-1"
      :style="{ width: config.inputWidth || '66px' }"
      v-model:value="field.value"
      :min="config.min || 0"
      :max="config.max || 100"
      @change="handleChange"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { props } from './helper';

export default defineComponent({
  props,
  emits: ['component-event'],
  setup() {
    return {};
  },
});
</script>
<style lang="less" scoped></style>
